import { handlePrice } from "../utils/utils.js";
import styles from "./SidePanel.module.css";

/**
 * Coluna lateral do portal (no celular aparece no fim da tela):
 * itens selecionados, total e o botão da etapa.
 */
const SidePanel = ({ title = "Resumo", items = [], totalLabel, total, note, children, steps }) => (
  <section className={styles.panel} aria-label={title}>
    <h2 className={styles.title}>{title}</h2>
    {items.length > 0 ? (
      <ul className={styles.items}>
        {items.map((item) => (
          <li key={item.key} className={styles.item}>
            {item.image ? <img src={item.image} alt="" /> : <span className={styles.fallback} aria-hidden="true" />}
            <span className={styles.itemText}>
              <span className={styles.itemName}>{item.title}</span>
              {item.meta ? <span className={styles.itemMeta}>{item.meta}</span> : null}
            </span>
            {item.price != null ? <span className={styles.itemPrice}>R$ {handlePrice(item.price)}</span> : null}
          </li>
        ))}
      </ul>
    ) : null}
    {steps ? (
      <ol className={styles.steps}>
        {steps.map((step) => (
          <li key={step.title}>
            <strong>{step.title}</strong>
            <span>{step.text}</span>
          </li>
        ))}
      </ol>
    ) : null}
    {total != null ? (
      <div className={styles.total}>
        <span>{totalLabel || "Total"}</span>
        <strong>R$ {handlePrice(total)}</strong>
      </div>
    ) : null}
    {note ? <p className={styles.note}>{note}</p> : null}
    {children ? <div className={styles.actions}>{children}</div> : null}
  </section>
);

export default SidePanel;
